import React, { useContext, useEffect, useState } from "react";
import { CommonModal } from "../../../AbstractElements";
import { Container, Form } from "reactstrap";
import { useForm } from "react-hook-form";

const CouponsModal = (props) => {
  const { register, watch, reset, handleSubmit, getValues } = useForm();

  const onInputChange = () => {
    let { searchtable } = getValues()
    props.couponSearch(searchtable)
  }
  let searchTableInput = watch('searchtable');


  return (
    <CommonModal
      isOpen={props.isOpen}
      title={props.title}
      toggler={props.toggler}
      size="md"
      bodyClass={"coupon-modal-body"}
    >
      <div className="coupon-search-table">
        <div className={`input-field ${searchTableInput ? 'input-active' : ''}`}>
          <input type="text" {...register('searchtable')} />
          <label htmlFor="searchtable">Enter Coupon Code</label>
          <button className="submit-search" onClick={() => onInputChange()}>Apply</button>
        </div>
      </div>
      <div className="available-text">Available Codes</div>
      <div className="coupons-list">
        {props.couponsData.map((coupon, index) => {
          return (
            <div key={coupon.id} className="individual-coupon-box">
              <div className="title-div">
                <div>{coupon.title}</div>
                <button
                  className="apply-btn"
                  onClick={() =>
                    props.couponApply(
                      coupon.code,
                      coupon.id,
                      props.carDetails[0].id
                    )
                  }
                >
                  Apply
                </button>
              </div>
              <div className="description">{coupon.description}</div>
              <div>
                <span className="code">{coupon.code}</span>
              </div>
            </div>
          );
        })}
      </div>
    </CommonModal>
  );
};

export default CouponsModal;
